import { baseUrl } from "./Controller/endpoints";

export const aiBaseURL = `${baseUrl}session`;
// "https://uwepfqcmq3.execute-api.ap-south-1.amazonaws.com/Dev/test";

export const competitorBaseURL =
  "https://maybank-chart-be-vjqo3gngua-el.a.run.app/";
export const catalogBaseURL = "https://faq-be-vjqo3gngua-el.a.run.app/faq";
export const datasetName = "Maybank";
export const perspective = "Maybank";
export const logoURL =
  "https://www.maybank.com/iwov-resources/images/icons/maybank_logo.svg";
export const client = "Maybank";

export const locales = [
  {
    locale: "English",
    code: "en-US",
  },
  {
    locale: "Malay",
    code: "ms-MY",
  },
  {
    locale: "Chinese",
    code: "zh-CN",
  },
  // {
  //     locale: "Chinese (Taiwan)",
  //     code: "zh-TW"
  // }
];
export const defaultLocale = locales[0].code;
